import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const responsiveContainerPadding = {
    paddingLeft: `${theme.spacing['6']}px`,
    paddingRight: `${theme.spacing['6']}px`,
    [`@media screen and (min-width: ${theme.breakpoints.sm}px)`]: {
      paddingLeft: `${theme.spacing['8']}px`,
      paddingRight: `${theme.spacing['8']}px`,
    },
  };

  return {
    appDetailsHeader: {
      backgroundColor: '#DAEAE4',
      ...responsiveContainerPadding,
    },
    contentContainer: {
      ...responsiveContainerPadding,
    },
    appDetailsHeaderLogo: {
      borderRadius: '5px',
      backgroundColor: theme.palette.background.light,
      boxShadow: '0px 1px 2px grey',
      maxHeight: '350px',
    },
    appDetailsHeaderLogoImg: {
      maxInlineSize: '100%',
      blockSize: 'auto',
      maxWidth: '300px',
    },
    textContainer: {
      width: '860px',
      [`@media screen and (max-width: ${theme.breakpoints.sm}px)`]: {
        width: '100%',
      },
    },
    appDetailsTab: {
      minHeight: '500px',
      padding: `${theme.spacing['4']}px ${theme.spacing['6']}px`,
      width: '860px',
      [`@media screen and (max-width: ${theme.breakpoints.lg}px)`]: {
        paddingLeft: 0,
        paddingRight: 0,
        width: '100%',
      },
    },
    appDetailsMediaGallery: {
      maxHeight: '150px',
    },
    appDetailsMediaModalImg: {
      maxInlineSize: '100%',
      blockSize: 'auto',
      height: 'auto',
      maxHeight: '80vh',
      maxWidth: '80wh',
    },
    appDetailsMediaModalYoutube: {
      height: '85vh',
      width: '75vw',
    },
    appDetailsYoutubeWrapper: {
      marginTop: `${theme.spacing['5']}px`,
      position: 'relative',
      paddingBottom: '56.25%',
      height: '0',

      [`@media screen and (min-width: ${theme.breakpoints.lg}px)`]: {
        marginTop: 0,
      },
    },
    appDetailsMediaModalYoutubeWrapper: {
      position: 'relative',
      paddingBottom: '56.25%',
      height: '0',
      marginTop: '5vw',
    },
    appDetailsYoutubeFrame: {
      position: 'absolute',
      border: 'none',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
    },
    appDetailsModalLeft: {
      display: 'flex',
      placeItems: 'center',
    },
    appDetailsModalMain: {
      display: 'flex',
      placeItems: 'center',
      justifyContent: 'center',
    },
    appDetailsModalRight: {
      display: 'flex',
      placeItems: 'center',
    },
    uninstallButton: {
      marginLeft: `${theme.spacing[2]}px`,
    },
  };
});

export default styles;
